var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDifficultyAdvanced(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 29,
    viewBox: "0 0 47 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.289 9.79804C28.544 9.36704 27.629 9.36404 26.884 9.79004L17.726 15.023C16.976 15.452 16.512 16.25 16.512 17.115V26.551C16.512 27.882 17.591 28.961 18.922 28.961H28.08C29.411 28.961 30.49 27.882 30.49 26.551V11.883C30.489 11.024 30.031 10.229 29.289 9.79804Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8989 19.1636C12.1549 18.7286 11.2389 18.7276 10.4939 19.1556L1.21488 24.4586C0.265885 24.9996 -0.200116 26.1126 0.0808844 27.1686C0.360884 28.2256 1.31688 28.9606 2.40988 28.9606H11.6899C13.0209 28.9606 14.0999 27.8816 14.0999 26.5506V21.2466C14.1009 20.3896 13.6429 19.5936 12.8989 19.1636Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7989 0.36372C45.0549 -0.0682802 44.1389 -0.0702802 43.3939 0.35672L34.1149 5.65872C33.3639 6.08772 32.8999 6.88672 32.8999 7.75172V26.5507C32.8999 27.8817 33.9789 28.9607 35.3099 28.9607H44.5889C45.9199 28.9607 46.9989 27.8817 46.9989 26.5507V2.44872C46.9999 1.58972 46.5419 0.79472 45.7989 0.36372Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDifficultyAdvanced);
export default __webpack_public_path__ + "static/media/difficultyAdvanced.54cbb7bfeda9e2ef9c7dc7ef3d0106b5.svg";
export { ForwardRef as ReactComponent };